// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import {
	PermissionGroup,
	User,
	UserExternalNotificationFrequency,
	UserNameOrder,
	UserPublicNameFormat,
	UserStatus,
} from "../../../Utilities";

export type Base = {
	imageKey: User["imageKey"];
	imageContentType: User["imageContentType"];
	givenName: User["givenName"];
	middleName: User["middleName"];
	familyName: User["familyName"];
	nameOrder: User["nameOrder"] | null;
	publicNameFormat: User["publicNameFormat"] | null;
	organizationName: User["organizationName"];
	gender: User["gender"];
	pronouns: User["pronouns"];
	dateOfBirth: User["dateOfBirth"] | null;
	email: User["email"];
	timeZoneName: User["timeZoneName"];
	permissionGroupIDs: PermissionGroup["id"][];
};

export type Create = Base;

export type CreateRequiredKey = Extract<keyof Create, "email">;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	imageKey: "",
	imageContentType: "",
	givenName: "",
	middleName: "",
	familyName: "",
	nameOrder: null,
	publicNameFormat: null,
	organizationName: "",
	gender: "",
	pronouns: "",
	dateOfBirth: null,
	email: "",
	timeZoneName: "",
	permissionGroupIDs: [],
};

export type Detail = Base & {
	name: User["name"];
	publicName: User["publicName"];
	status: User["status"] | null;
	passwordUpdatedAt: User["passwordUpdatedAt"] | null;
	isCurrent: User["isCurrent"];
	externalNotificationFrequency: User["externalNotificationFrequency"] | null;
};

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;

export const externalNotificationFrequencyOptions = [
	{ value: UserExternalNotificationFrequency.Daily },
	{ value: UserExternalNotificationFrequency.Never },
	{ value: UserExternalNotificationFrequency.Weekly },
];

export const nameOrderOptions = [{ value: UserNameOrder.FamilyGiven }, { value: UserNameOrder.GivenFamily }];

export const publicNameFormatOptions = [
	{ value: UserPublicNameFormat.FullName },
	{ value: UserPublicNameFormat.GivenNameFamilyInitial },
	{ value: UserPublicNameFormat.Hidden },
];

export const statusOptions = [
	{ value: UserStatus.Active },
	{ value: UserStatus.Created },
	{ value: UserStatus.Disabled },
	{ value: UserStatus.Invited },
];
